import Handsontable from 'handsontable'

export function TextRendererWithDataAttributes(instance, td, row, col) {
  Handsontable.renderers.TextRenderer.apply(this, arguments)
  td.setAttribute('data-test-row-idx', row)
  td.setAttribute('data-test-col-idx', col)
}
